import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-security-scrore',
  templateUrl: './security-scrore.component.html'
})
export class SecurityScroreComponent implements OnInit {
  @Input() deviceId = ''
  constructor(private _Service: ApiService, private router: Router, private commonService: CommonService) { }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.getDashboardDataById()
  }
  showUrl: boolean = false;
  ngOnInit(): void {
    if (this.router.url == '/home/main-content') {
      this.showUrl = true;
    }
  }
  securityScoreStatus: any;
  color: any;
  securityColor: any;
  securityRangeLeve1: any;
  securityRangeLeve2: any;
  getDeviceId: string = ''
  delimitervalue: number = 1;
  public canvasWidth = 300
  public needleValue = 1;
  public centralLabel = ''
  securityTotalScore: number = 0;
  securityScore: number = 0;
  securityRecommendations: any[] = [];
  options = {};
  options1 = {};
  isLoading: boolean = false;
  statusBg: string = '';
  statusClr: string = '';
  getDashboardDataById() {
    try {
      this.isLoading = true
      this._Service.getService(this._Service.API_URL.getDashboardDataById + this.deviceId).subscribe((response) => {
        if (response && response.status.code === 200) {
          let vinit;
          this.isLoading = false;
          this.securityScore = response.data.securityScore;
          this.commonService.securityscore.next(JSON.stringify(this.securityScore));
          this.securityTotalScore = response.data.securityTotalScore;
          this.securityRecommendations = response.data.securityRecommendations;
          this.delimitervalue = (response.data.securityScore / 10);
          if (this.delimitervalue >= 100) {
            this.delimitervalue = 99.9;
          }

          this.securityScoreStatus = response.data.securityScoreStatus;
          if (this.securityScore <= 250) {
            this.color = '#FF4B2B'
          } else if (this.securityScore >= 251 && this.securityScore <= 500) {
            this.color = '#FB6C6C'
          } else if (this.securityScore >= 501 && this.securityScore <= 800) {
            this.color = '#F59E0B'
          } else {
            this.color = '#1ECB1A'
          }
          if (this.securityScore >= 50) {
            this.securityColor = 'rgb(58, 215, 55, 1)'
          } else {
            this.securityColor = 'rgb(255, 65, 65, 1)'
          }
          this.options = {
            hasNeedle: true,
            needleColor: '#023047',
            needleUpdateSpeed: 1000,
            arcColors: [this.color, 'lightgray'],
            arcDelimiters: [this.delimitervalue ? this.delimitervalue : 1],
            needleStartValue: 0.1,
          }
          if (this.securityScore <= 250) {
            this.statusBg = "#FDDDDD";
            this.statusClr = "#FF4B2B";
          } else if (this.securityScore >= 251 && this.securityScore <= 500) {
            this.statusBg = "#FFF0F0";
            this.statusClr = "#FB6C6C";
          } else if (this.securityScore >= 501 && this.securityScore <= 800) {
            this.statusBg = "#FDECCE";
            this.statusClr = "#F59E0B";
          } else {
            this.statusBg = "#D5FED6";
            this.statusClr = "#1ECB1A";
          }

        }
      })
    } catch (error) {
      console.log(error);
    }

  }
}
